import { getAuthTokenAsync } from "src/store/common";
import { AppVersion } from "src/store/types";
import * as api from "./api";

interface AppVersionResponse {
  status: number;
  data: AppVersion[];
}

interface EditAppVersionPayload {
  latestVersion: number;
  minVersion: number;
}

export const fetchAppVersionsList = async (): Promise<AppVersionResponse> => {
  const token = await getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/app-versions/list`,
  );
  return response;
};

export const editAppVersion = async (
  id: number,
  payload: EditAppVersionPayload,
): Promise<any> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/app-versions/update/${id}`,
    payload,
  );
  return response;
};
